// extracted by mini-css-extract-plugin
export default {"container":"ErrorFallback_container__CiMbt","message":"ErrorFallback_message__kytIt","button":"ErrorFallback_button__qdl3z"};